style= require('./matches-confirmation.styl')
- var moment = require('moment')
.controls
  .panel
    .control
      .show(class={inactive:this.shown})
        ft-button.button(accent, (click)=this.seasonsSelect())= 'Select seasons'
        if seasons
          .all-seasons= `All seasons (${seasons.length})`
      .back(class={inactive:!this.shown})
        .back-arrow((click)=this.goBack())
          ft-icon(name=`ui--arrow_left`)
        .label= 'Go back'
      .gap(class={inactive:!this.shown})
      if this.shown
        ft-toggle(
          (change)=this.toggleSportsbookOnly(),
          checked=this.sportsbookOnly
        ) Sportsbook Only and Claimed
      .gap(class={inactive:!this.shown})
      .deselect(class={inactive:!this.shown})
        ft-button(accent, (click)=this.deselect())= "Deselect all"
        .label= `${seasonFilter.length} season(s) selected`
if !this.shown
  .panel
    .control
      ft-dropdown.dropdown(icon)
        header.dropdown-header(slot="header")
          if this.sport
            .dropdown-icon
              ft-icon(name=`sports--${this.sport}`)
          span.dropdown-text=(this.sport) || 'All sports'
        each s in sports
          .dropdown-item(role='option', value=s, (click)=this.changeSport(s),selected=(s == this.sport))
            if s
              .dropdown-icon
                ft-icon(name=`sports--${s}`)
            span= s
      sporty-seasons(
        sport= this.sport,
        season=season,
        (change:season)=changeSeason(e),
        blank="<All seasons>")
  section.matches-confirmation
    .spacer
      filter-dropdown.calendar
        sporty-form-field([(value)]=this.after)
          input(type='date' placeholder='dd/mm/yyyy')
      ft-dropdown.dropdown(icon)
        header.dropdown-header(slot="header")
          span.dropdown-text=(this.filterType)
        each status in ['All statuses', 'Live', 'Pending', 'Ended', 'Confirmed', 'Cancelled']
          ft-toggle(
            role='option',
            [value]=status,
            (toggle)=this.changeFilterType(status),
            checked=(filterType?.indexOf(status)!==-1)
            )
            span= status
      ft-dropdown.dropdown(icon)
        header.dropdown-header(slot="header")
          span.dropdown-text=(this.roundNum)
        each r in rounds
          .dropdown-item(role='option', value='GW:'+ r, (click)=this.changeRoundNum(r), selected=(r == this.roundNum))
            span= 'GW:'+ r
      ft-button.reload(accent, (click)=this.reload())= 'Reload'

    - var round
    - var score
    - var status
    - var color
    - var season
    each match in arrayMatches
      - color = styleStatus(match.status)
      if ['american_football', 'football', 'hockey'].includes(match.sport) && !match.season?.sportsbookOnly
        - score = formatScore(match.subScore)
      else
        - score = formatScore(match.score)
      - status = match.status
      if status == 'pending'
        - score = ' - - - '
      if season !== match.seasonId && matchround !== match.round
        - round = match.round
        - season = match.seasonId
        header.round-header
          ft-icon(name=`sports--${match.season.sport}`)
          .round= `${match.season?.sport}, ${match.season?.name}, Round ${round}`

      .match
        if match.isDuel
          .name
            if match.homeTeam
              .home= match.homeTeam.name
            else
              .home= 'homeTeam'
            .score= `${score}`
            if match.awayTeam
              .away= match.awayTeam.name
            else
              .away= 'awayTeam'
        else
          .name= match.name
        if match.season.autoconfirm
          ft-toggle(
            checked=match.autoconfirm,
            (toggle)=this.toggleAutoconfirm(match)
          ) AC
        .time= moment(match.startTime).format('lll')
        .status(style=`color: ${color}`)= `${status}`
        ft-button.scrape(warning,
          class= {'hide-scrape': !match.uid},
          (click)=this.scrapeFeeds(match),
          ) Scrape
        ft-button.feeds(transparent,
          (click)=toggleFeeds(match),
          )=match.stopFeeds ? 'Unlock feeds' : 'Lock feeds'
        ft-button.dashboard(success,
          href=`/dashboard/${match._id}`,
          target='_blank',
          ) Dashboard
        ft-button.confirm(danger,
          class= {'hide-confirm': !(status === 'ended' || status === 'confirmed')},
          disabled = (status === 'confirmed'),
          (click) = this.prompt('confirmed', 'confirm', 'Really CONFIRM?', match._id)) Confirm & Send
        ft-button.events(info,
          (click) = this.sendEvents(match._id)) Send Events
if this.shown
  each sport, index in this.sortedSeasons
    .sport-block
        ft-icon(name=`sports--${sport.type}`)
        .sport= sport.type
        .count= ` (${this.sortedSeasons[index].sortedSeasons.length})`
    .seasons
      each season in sortedSportSeasons(sport)
        if seasonCheck(season)
          .season.checking(
            class=this.seasonClass(season),
            data-season=season._id,
            (click)=this.toggle(season._id)
          )
            .section
              img.season-icon(src=season.iconUrl)
              .icon-name
                section
                  .name= [season.league.name, season.season].join(' ')
                section
                  .live
                    - var live = seasonCount[season._id]
                    if live
                      .status-text #{live} live games
            .toggle(class= {'checked': this.seasonClass(season) === 'selected'})
              ft-icon(name="ui--tick")
